import styled from "styled-components";

export const DownloadAppImg = styled.img`
    margin-top: 15px;
    margin-bottom: 15px;
`;


// WEBPACK FOOTER //
// ./src/Components/DownloadApp/DownloadAppStyle.js